<template>
  <div>
    <title>电话提货</title>
    <section class="serviceBox">
      <!-- S 券卡验证表单 -->
      <el-form :model="serviceForm" inline class="serviceForm">
        <el-form-item v-if="pubordprintinfo.bopendisrange === 1" label="配送至" required>
          <!-- S 选择地址组件 -->
          <ProvincesOrCity
            v-model="serviceForm.sendToAddr"
            :valueType="'nv'"
            :level="sendToLevel"
            :placeholder="sendToPlaceholder"
            v-on:change="sendToAddrChange"
          ></ProvincesOrCity>
          <!-- E 选择地址组件 -->
        </el-form-item>
        <el-form-item>
          <el-select v-model="serviceForm.verifyType" class="formTimeSlot">
            <el-option
              v-for="(item,index) in serviceTypeData"
              :label="item.name"
              :value="item.value"
              v-bind:key="item.value + index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="codeSerIpt">
          <el-input
            v-show="serviceForm.verifyType == 0"
            v-model.trim="serviceForm.cardCode"
            maxlength="20"
            placeholder="填写券卡编码"
            clearable
            ref="codeRef"
            @keyup.enter.native="toNext(0)"
          ></el-input>
          <el-input
            v-show="serviceForm.verifyType == 1"
            v-model.trim="serviceForm.cardSerial"
            placeholder="填写序列号"
            clearable
            ref="serialRef"
            @keyup.enter.native="toNext(1)"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证密码" v-if="ischeckpwd==1" class="formTimeSlot" ref="pwdRef" @keyup.enter.native="toNext(2)">
          <el-input v-model.trim="serviceForm.cardPwd" placeholder="填写卡密" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="validateLoading" @click="validate">验证</el-button>
          <!-- <el-button v-if="ElementControls('importBatchPreOrder') == 1" type="danger" plain @click="importCoderShow = true">批量导入卡券提货</el-button> -->
        </el-form-item>
      </el-form>
      <!-- S 券卡验证表单 -->

      <!--S 验证券卡列表-->
      <div class="serviceWrap">
        <p class="commonTit">
          <b>券卡信息</b>
          <em>
            (已验证
            <i class="commonNum">{{cardVertifyData.length}}</i> 张)
          </em>
          <span class="goodsSummary iconsw" @click="goodsSummary = true" v-if="cardVertifyData.length>0 || cardOrderno">商品汇总</span>
        </p>
        <el-table class="comTable cardVertifyTab" border :data="cardVertifyData" maxHeight="165">
          <el-table-column label="序号" type="index" fixed></el-table-column>
          <el-table-column label="券卡编码" fixed width="200">
            <template slot-scope="scope">
              <p>{{ scope.row.code}}</p>
              <em>【{{scope.row.serial}}】</em>
            </template>
          </el-table-column>
          <el-table-column label="本次消耗次数" min-width="200">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.consumpteTimes"
                v-on:change="consumpteTimesChange($event,scope.row)"
                size="mini"
                :min="1"
                :max="scope.row.residuenum"
                :step="1"
                step-strictly
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="剩余次数" prop="consumpteTimes" sortable min-width="130">
            <template slot-scope="scope">{{ scope.row.residuenum-scope.row.consumpteTimes}}</template>
          </el-table-column>
          <el-table-column label="已选商品" min-width="130">
            <template slot-scope="scope">
              <span
                class="cityName iconhand textFl"
                @click="getShowChoseGoods(scope.row)"
              >{{scope.row.goods.length}}</span>
            </template>
          </el-table-column>
          <el-table-column label="售卡渠道" prop="sellChannel" sortable min-width="120">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.sellChannel">{{ scope.row.sellChannel}}</p>
            </template>
          </el-table-column>
          <el-table-column label="面单打印说明" min-width="200">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.printMemo">{{scope.row.printMemo | empty}}</p>
            </template>
          </el-table-column>
          <el-table-column label="客服备注" min-width="200">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.memo">{{scope.row.memo | empty}}</p>
            </template>
          </el-table-column>
           <el-table-column label="出库备注" min-width="200">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.cardoutmemo">{{scope.row.cardoutmemo | empty}}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="100">
            <template slot-scope="scope">
              <p class="handle">
                <span
                  v-if="scope.row.canChangeGoods"
                  title="更改商品"
                  @click="getShowChoseGoods(scope.row)"
                ><i class="iconedit"></i></span>
                <span title="删除" @click="deleteRow(scope.$index)"><i class="icondel"></i></span>
              </p>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="noData smallNOdata">
              <span>暂无数据</span>
            </div>
          </template>
        </el-table>
      </div>
      <!--E 验证券卡列表-->

      <!--S 提货历史记录-->
      <div v-if="historyAddrData.length > 0" class="serviceWrap">
        <p class="commonTit">
          <b>提货历史记录</b>
        </p>
        <el-table class="comTable cardVertifyTab" border :data="historyAddrData" maxHeight="210">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="订单号" min-width="230">
            <template slot-scope="scope">{{ scope.row.orderno}}</template>
          </el-table-column>
          <el-table-column label="收货人姓名" min-width="250">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.receivername">{{scope.row.receivername}}</p>
            </template>
          </el-table-column>
          <el-table-column label="收货人电话" min-width="250">
            <template slot-scope="scope">{{ scope.row.receivertel}}</template>
          </el-table-column>
          <el-table-column
            :label="pubordprintinfo.bopendisrange === 1 ? '地址（收货地址与配送至不匹配的将不会映射地址）' : ''"
            prop="fulladdr"
            sortable
            min-width="350"
          >
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.fulladdr">{{scope.row.fulladdr}}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <span class="icondw" title="映射地址" @click="copyAddr(scope.$index, scope.row)">映射地址</span>
            </template>
          </el-table-column>
          <template slot="empty">
                  <div class="noData"><span>暂无数据</span></div>
                </template>
        </el-table>
      </div>
      <!--E 提货历史记录-->

      <!--S 提货表单-->
      <div class="deliveryForm">
        <p class="commonTit">
          <b>收货信息</b>
        </p>
        <el-form
          ref="telDeliveryForm_ref"
          :model="telDeliveryForm"
          :rules="delieveryRules"
          label-width="180px"
          class="comForm"
        >
          <el-row class="goodsWrap">
            <el-col :span="12">
              <el-form-item label="收货人电话" prop="receiptTel">
                <el-input
                  v-model.trim="telDeliveryForm.receiptTel"
                  placeholder="请输入收货人电话"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="收货人姓名" prop="receiptName">
                <el-input v-model="telDeliveryForm.receiptName" clearable placeholder="请输入收货人姓名"></el-input>
              </el-form-item>
              <el-form-item label="收货地址" prop="receiptAddr">
                <!-- S 选择地址组件：开通配送范围时非三级仍只选区县；三级时与配送至同步且只读 -->
                <ProvincesOrCity
                  v-model="telDeliveryForm.receiptAddr"
                  :valueType="'nv'"
                  :level="receiptAddrLevel"
                  :initCode="receiptAddrInitCode"
                  :placeholder="receiptAddrPlaceholder"
                  :isDisabled="isReceiptAddrDisabled"
                ></ProvincesOrCity>

                <!-- E 选择地址组件 -->
              </el-form-item>
              <el-form-item prop="receiptAddrDetail">
                <el-input
                  type="textarea"
                  v-model="telDeliveryForm.receiptAddrDetail"
                  placeholder="输入详细地址，如门牌号，不少于5个字"
                  maxlength="80"
                  minlength="5"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="持卡人电话" class="defineRow" prop="cardHolderTel">
                <el-input
                  v-model.trim="telDeliveryForm.cardHolderTel"
                  type="number"
                  maxlength="16"
                  placeholder="请输入持卡人电话"
                  clearable
                ></el-input>
                <el-button
                  type="primary"
                  plain
                  class="btnRight"
                  @click="getShowChoseMem(0)"
                >{{bindMemberInfo ? '取消绑定' : '绑定会员'}}</el-button>
              </el-form-item>
              <el-form-item label="已绑账号" v-if="memberBox && bindMemberInfo">
                <div class="flexUpDownCenter memberPop">
                  <span class="memberImg">
                    <img
                      :src="bindMemberInfo.hpurl ? bindMemberInfo.hpurl : 'https://presale.jhtsoft.com/picms/c47519dc61feb.png'"
                      alt="会员头像"
                    />
                  </span>
                  <div class="memberInfo">
                    <strong class="flexUpDownCenter">
                      <span :title="bindMemberInfo.nickname ? bindMemberInfo.nickname : '匿名会员'">{{bindMemberInfo.nickname ? bindMemberInfo.nickname : '匿名会员'}}</span>
                      <i
                        :class="{iconmale: bindMemberInfo.sex == 0, iconfemale: bindMemberInfo.sex == 1}"
                      ></i>
                    </strong>
                    <b class="commonNum" v-if="bindMemberInfo.mphone">{{bindMemberInfo.mphone ? bindMemberInfo.mphone : '--'}}</b>
                    <em :title="bindMemberInfo.mlevelname ? bindMemberInfo.mlevelname : ''">{{bindMemberInfo.mlevelname ? bindMemberInfo.mlevelname : '--'}}</em>
                  </div>
                  <el-link type="primary" :underline="false" @click="getShowChoseMem(1)">修改</el-link>
                </div>
              </el-form-item>
              <el-form-item
                :label="pubordprintinfo.expecttitle ? pubordprintinfo.expecttitle : '期望发货日期'"
                class="defineRow mb0"
                prop="sendDate"
              >
                <el-date-picker
                  v-model="telDeliveryForm.sendDate"
                  type="date"
                  :picker-options="sendDateLimit"
                  placeholder="选择日期"
                  align="right"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-select
                  v-if="apmShow"
                  v-model="telDeliveryForm.timeSlot"
                  placeholder="请选择"
                  class="btnRight selSlot"
                >
                  <el-option
                    v-for="(item,index) in timeSlotDatas"
                    :label="item.label"
                    :value="item.value"
                    v-bind:key="item + index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-link type="primary" :underline="false" @click="showSelgdsDateBox">查看已选商品销售日期</el-link>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备用号码" prop="backupTel">
                <el-input v-model.trim="telDeliveryForm.backupTel" clearable placeholder="请输入备用号码"></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="receiptemail">
                <el-input v-model="telDeliveryForm.receiptemail" placeholder="请输入收货人邮箱" clearable></el-input>
              </el-form-item>
              <el-form-item label="公司名称" prop="companyName">
                <el-input v-model="telDeliveryForm.companyName" clearable placeholder="请输入公司名称"></el-input>
              </el-form-item>
              <el-form-item prop="buyerMemo">
                <p class="labelTip">
                  <label>买家备注</label>
                  <small v-show="ElementControls('showbuyermemo')==1">此备注打印在面单上</small>
                </p>
                <el-input
                  type="textarea"
                  v-model="telDeliveryForm.buyerMemo"
									placeholder="买家备注不能小于5个字符"
                  maxlength="50"
                  minlength="5"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item prop="orderMemo">
                <p class="labelTip">
                  <label>订单备注</label>
                  <small v-show="ElementControls('showbuyermemo')==1">此备注仅供内部查阅</small>
                </p>
                <el-input
                  type="textarea"
                  v-model="telDeliveryForm.orderMemo"
									placeholder="订单备注不能小于5个字符"
                  maxlength="50"
                  minlength="5"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!--E 提货表单-->

      <div class="bottomBtn">
        <el-button type="primary" :loading="submitLoading" @click="submitDeliveryForm()">提交</el-button>
        <el-button @click="$router.back(-1)">返回</el-button>
      </div>
    </section>

    <!-- S 选择可选商品 -->
    <GoodsChoose
      v-if="goodsChoseDialogVisible"
			 :delmode="1"
      :goodsChoseDialogVisible="goodsChoseDialogVisible"
      :lookOrEditType="lookOrEdit"
      :code="currentCode"
      :initUseTimes="currentUseTimes"
      :initSelectGoods="currentCodeInfo.goodsMap"
      :enAbleEdite="currentEnAbleEdite"
      @closeChild="getCloseGoodsCld"
      v-on:selectSubmit="goodsSelectSubmit($event)"
    ></GoodsChoose>
    <!-- E 选择可选商品 -->

    <!-- S 选择会员 -->
    <MemberChose
      v-if="memberChoseDialogVisible"
      :isAdd="1"
      :initSelected="bindMemberInfo"
      :memberChoseDialogVisible="memberChoseDialogVisible"
      @closeChild="getCloseMemberCld"
      v-on:selected="memberSelected($event)"
    ></MemberChose>
    <!-- E 选择会员 -->

    <!--S 已选商品销售日期-->
    <el-dialog
      class="comDlog goodsDateDlog"
      title="已选商品销售日期"
      :visible.sync="selgdsDateBox"
      :before-close="closegsDateBox" append-to-body :close-on-click-modal="false"
    >
      <el-table :data="goodsDateData" border class="comTable" maxHeight="337">
        <el-table-column type="index" width="100" label="序号"></el-table-column>
        <el-table-column label="日期">
          <template slot-scope="scope">{{scope.row}}</template>
        </el-table-column>
        <template slot="empty">
          <div class="noData">
            <span>暂无数据</span>
          </div>
        </template>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closegsDateBox">关闭</el-button>
      </div>
    </el-dialog>
    <!--E 已选商品销售日期-->
     <!-- S 获取验证码弹窗 -->
    <telDialog :checkVisible='checkVisible' :type="2"  @telDlog="telDlog" :tels="telDeliveryForm.receiptTel"></telDialog>
    <!-- E 获取验证码弹窗 -->
     <!--S 超出配送范围弹窗提示-->
    <el-dialog class="comDlog comMsgDlg outAreaDlg" title="系统提示" :visible.sync="outAreaShow" append-to-body :close-on-click-modal="false">
      <div class="msgContBox">
        <i class="el-message-box__status el-icon-warning"></i>
        <h4>已有券卡通过验证，切换"<b class="blueColor">配送至</b>"会清空已验证券卡, 是否继续?</h4>
        <p v-if="outAreaGoodsName.length>0">以下商品已超出配送范围，请更换其他商品</p>
        <ul :class="{'inlineUl':outAreaGoodsName.length>=5}" v-show="outAreaGoodsName.length>0">
          <li v-for="(item,index) in outAreaGoodsName" :key="index" :title="item.goodsname">{{index+1}}、{{item.goodsname}}</li>
        </ul>
        <p v-if="outAreaGoodsCode.length>0">以下券卡已超出配送范围</p>
        <ul :class="{'inlineUl':outAreaGoodsCode.length>=5}" v-show="outAreaGoodsCode.length>0">
          <li v-for="(item,index) in outAreaGoodsCode" :key="index">{{index+1}}、{{item.code}}</li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="confirmPush(1)" :loading="button_loading">确定</el-button>
        <el-button size="small" @click="confirmPush(0)">取消</el-button>
      </span>
    </el-dialog>
    <!--E 超出配送范围弹窗提示-->

    <!--S 商品汇总弹窗-->
    <GoodsSummary :goodsSummaryShow="goodsSummary" :orderno="cardOrderno" :cardData="cardVertifyData" :deliveryType="0" @closeSummaryBox="getCloseSummaryBox"></GoodsSummary>
    <!--E 商品汇总弹窗-->

    <!--S 提交成功提示框-->
    <el-dialog class="comDlog alertMsgDlog" title="系统提示" :visible.sync="submitDeliveryBox" append-to-body :close-on-click-modal="false" :before-close="closeSubmitPop">
      <div class="alertBox">
        <i class="el-icon-success"></i>
        <h2 class="comAlert">提货成功！</h2>
        <p>生成订单号：<em class="orangeColor cursorHand iconhand cityName" @click="orderCardInfo()" title="点击查看商品汇总">{{orderno}}</em></p>
        <small>点击订单号可查看当前订单所有商品汇总信息哦~</small>
      </div>
      <p class="msgBtns">
        <el-button type="primary" size="small" @click="closeSubmitPop">关闭</el-button>
      </p>
    </el-dialog>
    <!-- E 提交成功提示框 -->

    <!-- 批量导入卡券提货 -->
    <!-- <template v-if="ElementControls('importBatchPreOrder') == 1">  
      <ImportBatchOrder :importCoderShow="importCoderShow" @closeODBox="closeImportBatchOrder"></ImportBatchOrder>
    </template> -->
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import Api from "@/apis/api.js";
export default {
  name: "TelDelivery",
  components: {
    GoodsChoose: resolve =>
      require(["@/components/OrderFolder/GoodsChoose.vue"], resolve), //选择可选商品
    MemberChose: resolve =>
      require(["@/components/common/MemberChose.vue"], resolve), //选择会员
    ProvincesOrCity: resolve =>
      require(["@/components/common/ProvincesOrCity.vue"], resolve), // 选择地址插件组件
    telDialog: resolve => require(["@/components/common/telDialog.vue"],resolve),
    GoodsSummary: resolve => require(["@/components/OrderFolder/GoodsSummary.vue"], resolve), //商品汇总
    // ImportBatchOrder: () => import("@/components/OrderFolder/ImportBatchOrder.vue"), //批量导入卡券提货
  },
  data() {
    var that = this;
    return {
      button_loading:false,
      Addercity:'',
      outAreaShow:false,//超出配送范围弹窗
      outAreaGoodsCode:[],
      outAreaGoodsName:[],
      checkVisible:false,
      alivm:false,//阿里验证短信是否开启
      ischeckpwd:0,
      pubordprintinfo: null,
      presellconfig: null,
      currentCode: "",
      currentUseTimes: 1,
      currentCodeInfo: null,
      firstTimes: false,
      currentEnAbleEdite: true,
      apmShow: false,
      validateLoading: false,
      submitLoading: false,
      bindMemberInfo: null,
      serviceForm: {
        sendToAddr: [],
        verifyType: 0, //验证类型,0:卡号，1:序列号
        cardCode: "", //券卡编码
        cardPwd: "", //卡密
        cardSerial: "" //序列号
      },
      cardVertifyData: [],
      historyAddrData: [],
      telDeliveryForm: {
        //提货表单
        receiptTel: "", //收货人电话
        receiptName: "", //收货人姓名
        receiptemail: "", //邮箱
        receiptAddr: [], //收货省市区
        receiptAddrDetail: "", //收货详细地址
        cardHolderTel: "", //持卡人电话
        sendDate: "", //期望发货日期
        backupTel: "", //备用电话
        companyName: "", //公司名称
        buyerMemo: "", //买家备注
        orderMemo: "", //订单备注
        timeSlot: -1
      },
      timeSlotDatas: [
        { label: "全天", value: -1 },
        { label: "中午", value: 0 },
        { label: "晚上", value: 1 }
      ],
      delieveryRules: {
        companyName: [
          { max: 50, message: "公司名称不能大于50个字！", trigger: "blur" }
        ],
        buyerMemo: [
          { max: 50, message: "买家备注不能大于50个字！", trigger: "blur" }
        ],
        orderMemo: [
          { max: 50, message: "订单备注不能大于50个字！", trigger: "blur" }
        ],
        cardHolderTel: [
          {
            validator: function(rule, value, callback) {
              if (value&&value.length>16) {
                callback(new Error("请输入合法的手机号码！"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        receiptTel: [
          {
            required: true,
            message: "请填写收货人电话",
            trigger: "blur"
          },
          {
            validator: function(rule, value, callback) {
              if(that.ElementControls('enordertel') !=1){
                 if (value.length != 11) {
                  callback(new Error("仅支持输入手机号码！"));
                } else {
                  callback();
                }
              }else{
                if (value.length > 16) {
                  callback(new Error("手机号码或固话号码格式不正确！"));
                } else {
                  callback();
                }
              }
            },
            trigger: ["blur","change"]
          }
        ],
        backupTel: [
          {
            validator: function(rule, value, callback) {
              if (value&&value.length>16) {
                callback(new Error("请输入合法的手机号码！"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        receiptemail: [
          { type: "email", message: "请输入合法的邮箱！", trigger: "blur" }
        ],
        receiptName: [
          { required: true, message: "请填写收货人姓名！", trigger: "blur" },
          { max: 30, message: "收货详细地址不能大于30个字！", trigger: "blur" }
        ],
        receiptAddr: [
          {
            type: "array",
            required: true,
            message: "请选择区域",
            trigger: "change"
          }
        ],
        receiptAddrDetail: [
          { required: true, message: "请填写收货详细地址！", trigger: "blur" },
          { min: 5, message: "收货详细地址不能少于5个字！", trigger: "blur" },
          { max: 80, message: "收货详细地址不能大于50个字！", trigger: "blur" }
        ],
        sendDate: [
          { required: true, message: "请选择期望发货日期！", trigger: "blur" }
        ]
      },
      goodsChoseDialogVisible: false, //选择可选商品弹框
      lookOrEdit: false, //查看or更改商品
      memberBox: false, //已选会员
      memberChoseDialogVisible: false, //选择会员弹框
      selgdsDateBox: false, //已选商品销售日期弹窗
      goodsDateData: [],
      sendDateLimit: {
        // 期望发货日期只能选择不小于今天的日期
        disabledDate: function(cdate) {
          return cdate.getTime() < Date.now() - 3600 * 1000 * 24;
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "明天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      //-------------新加商品汇总弹窗信息---------------------
      goodsSummary:false,//商品汇总弹窗
      submitDeliveryBox:false,//提交成功的提示
      orderno:'',//订单号
      cardOrderno: '', // 传递给组件的订单号
      importCoderShow:false,//批量导入卡券提货弹窗
    };
  },
  methods: {
    //关闭导入弹窗
    closeImportBatchOrder(val){
      this.importCoderShow = false;
    },
    // enter键确认事件 type为对应的步数
    toNext(type) {
      if(this.ischeckpwd==1) {
        if(type == 0) {
          this.$refs.pwdRef.focus();
        } else if(type == 1) {
          this.$refs.pwdRef.focus();
        } else if(type == 2) {
          this.validate()
        }
      } else {
        this.validate();
      }
    },
    confirmPush(type){
      this.button_loading = true;
      if(type==1){
         this.initPick();
         this.button_loading = false;
         this.outAreaShow = false;
      }else{
         this.serviceForm.sendToAddr = this.Addercity;
         this.button_loading = false;
         this.outAreaShow = false;
      }
    },
    sendToAddrChange: function(data) {

      console.log("sendToAddrChange", data, this.serviceForm.sendToAddr);
      if (this.serviceForm.sendToAddr.length < this.sendToMinLen) {
        return;
      }
      if (this.cardVertifyData.length > 0) {
        let param = {
          provincecode: this.serviceForm.sendToAddr[0].code,
          citycode: this.serviceForm.sendToAddr[1].code
        };
        if (this.isAreaRange3) {
          param.districtcode = this.serviceForm.sendToAddr[2].code;
        }
        Api.VALCITYANDOKSET(param).then(res=>{
              if(res.data.status=="200"){
                  this.syncReceiptAddrFromSendTo();
              }else{
                this.outAreaShow = true;
                this.Addercity = data.before;
                this.outAreaGoodsCode =[];
                this.outAreaGoodsName =[];
                if(res.data.data.code&&res.data.data.code!=null){
                   this.outAreaGoodsCode = res.data.data.code;
                }
                if(res.data.data.name&&res.data.data.name!=null){
                   this.outAreaGoodsName = res.data.data.name;
                }
                  // this.$confirm(
                  //     "已有券卡通过验证，切换配送至会清空已验证券卡, 是否继续?",
                  //     "提示",
                  //     {
                  //       confirmButtonText: "确定",
                  //       cancelButtonText: "取消",
                  //       type: "warning"
                  //     }
                  //   )
                  //     .then(() => {
                  //       this.initPick();
                  //     })
                  //     .catch(() => {
                  //       this.serviceForm.sendToAddr = data.before;
                  //     });
              }
        })
        
      } else {
        this.initPick();
      }
    },
    // goodsAreaRange==2 时：收货地址与配送至省市区同步
    syncReceiptAddrFromSendTo: function() {
      if (
        !this.pubordprintinfo ||
        this.pubordprintinfo.bopendisrange !== 1 ||
        !this.isAreaRange3 ||
        this.serviceForm.sendToAddr.length < 3
      ) {
        return;
      }
      this.telDeliveryForm.receiptAddr = this.serviceForm.sendToAddr.map(item => {
        return { code: item.code, name: item.name };
      });
    },
    checkMapGoods: function() {
      Api.HASRANGEGOODS({}).then(res => {
        if (res.data.status !== "200") {
          Message.error({ message: res.data.message });
          return;
        }
        if (res.data.data > 0) {
          this.apmShow = true;
        }
      });
    },
    showSelgdsDateBox: function() {
      Api.GET_SELECTEDGOODSSALESDATES({}).then(res => {
        this.goodsDateData = res.data.data;
        this.selgdsDateBox = true;
      });
    },
    getValidateCodeInfoByCode: function(code) {
      for (let item of this.cardVertifyData) {
        if (item.code === code) {
          return item;
        }
      }
    },
    goodsSelectSubmit: function($event) {
      console.log("selectedGoodsDatas", $event);
      let param = { code: $event.code, usenum: $event.useTimes };
      let goodsInfo = $event.goodsinfo;
      let goodsInfos = [];
      let goodsMap = {};
      if ($event.type === 0) {
        // 有默认商品
        if ($event.selectDefaultGoods === 1) {
          param.isSelectDef = 1;
          param.defaultgoodscode = goodsInfo["singleList"][0].kindcode;
        } else {
          param.isSelectDef = 0;
          param.kindcodes = {};
          param.kindcodes["1"] = goodsInfo["singleList"][0].kindcode;
        }
        goodsInfos.push(goodsInfo["singleList"][0]);
        goodsMap["singleList"] = goodsInfo["singleList"];
      } else {
        // 无默认商品
        param.isSelectDef = 0;
        let kindcodes = {};

        for (let key in goodsInfo) {
          let kindcodeStr = [];
          for (let item of goodsInfo[key]) {
            kindcodeStr.push(item.kindcode);
            goodsInfos.push(item);
          }
          kindcodes[key.split("@")[1]] = kindcodeStr.join("@");
          goodsMap[key.split("@")[0]] = goodsInfo[key];
        }

        param.kindcodes = kindcodes;
      }

      this.currentCodeInfo.goods = goodsInfos;
      this.currentCodeInfo.kindcodes = param.kindcodes;
      this.currentCodeInfo.goodsMap = goodsMap;

      var hasValidateInfo = this.cardVertifyData.find(item => {
        if (item.code === this.currentCodeInfo.code) {
          return item;
        }
      });

      if (hasValidateInfo) {
        hasValidateInfo.goods = this.currentCodeInfo.goods;
        hasValidateInfo.kindcodes = this.currentCodeInfo.kindcodes;
        hasValidateInfo.goodsMap = this.currentCodeInfo.goodsMap;
      } else {
        this.cardVertifyData.push(this.currentCodeInfo);
      }

      this.currentCodeInfo = null;

      // 情况表单
      this.clearCodeParam();

      Api.SETCARDGOODS(param).then(res => {
        if (res.data.status !== "200") {
          Message.error({ message: res.data.message });
          return;
        }
        // 校验已选商品中是否有地图配送商品
        this.checkMapGoods();
      });
    },
    //删除券卡验证行
    deleteRow(index) {
      Api.REMOVEVALIDATEDCARD({ code: this.cardVertifyData[index].code }).then(
        res => {
          let data = res.data;
          if (data.status === "200") {
            this.cardVertifyData.splice(index, 1);
          } else {
            Message.error({ message: data.message });
          }
        }
      );
    },
    // 打开选择可选商品弹窗
    getShowChoseGoods(item) {
      this.currentCode = item.code;
      this.currentUseTimes = item.consumpteTimes;
      this.currentCodeInfo = item;
      this.firstTimes = false;
      this.goodsChoseDialogVisible = true;
    },
    // 关闭选择可选商品弹窗
    getCloseGoodsCld() {
      if (
        this.firstTimes &&
        this.currentCodeInfo &&
        this.currentCodeInfo.code
      ) {
        Api.REMOVEVALIDATEDCARD({ code: this.currentCodeInfo.code }).then(
          res => {
            let data = res.data;
            if (data.status === "200") {
              this.goodsChoseDialogVisible = false;
            } else {
              Message.error({ message: data.message });
            }
          }
        );
      } else {
        this.goodsChoseDialogVisible = false;
      }
    },
    // 映射地址
    copyAddr(index, row) {
      if (this.pubordprintinfo.bopendisrange === 1) {
        if (this.serviceForm.sendToAddr.length < this.sendToMinLen) {
          Message.error({ message: "请选择配送至！" });
          return;
        }
        this.telDeliveryForm.receiptTel = row.receivertel;
        this.telDeliveryForm.receiptName = row.receivername;
        this.telDeliveryForm.backupTel = row.othtel?row.othtel:'';
        if (this.isAreaRange3) {
          // 三级：仅当地址与配送至市+区一致时映射详细地址，省市区保持与配送至同步
          let sendCity = this.serviceForm.sendToAddr[1].code;
          let sendDistrict = this.serviceForm.sendToAddr[2].code;
          this.syncReceiptAddrFromSendTo();
          if (
            row.citycode === sendCity &&
            row.districtcode === sendDistrict &&
            row.fulladdr
          ) {
            this.telDeliveryForm.receiptAddrDetail = row.addrdet;
          }
        } else if (row.citycode === this.serviceForm.sendToAddr[1].code) {
          this.telDeliveryForm.receiptAddr = [
            { code: row.districtcode, name: row.district }
          ];
          if (row.fulladdr) {
            this.telDeliveryForm.receiptAddrDetail = row.addrdet;
          }
        }
      } else {
        this.telDeliveryForm.receiptTel = row.receivertel;
        this.telDeliveryForm.receiptName = row.receivername;
        this.telDeliveryForm.backupTel = row.othtel?row.othtel:'';
        this.telDeliveryForm.receiptAddr = [
          { code: row.provincecode, name: row.province },
          { code: row.citycode, name: row.city },
          { code: row.districtcode, name: row.district }
        ];
        if (row.fulladdr) {
          this.telDeliveryForm.receiptAddrDetail =row.addrdet
        }
      }
    },
    // 打开选择会员弹窗
    getShowChoseMem(val) {
      if (val) {
        this.memberBox = true;
      } else {
        this.memberBox = !this.bindMemberInfo;
        this.bindMemberInfo = null;
      }
      if (this.memberBox) {
        this.memberChoseDialogVisible = true;
      }
    },
    // 关闭选择会员弹窗
    getCloseMemberCld() {
      this.memberChoseDialogVisible = false;
    },
    memberSelected: function(memberInfo) {
      this.bindMemberInfo = memberInfo;
    },
    //关闭销售日期弹窗
    closegsDateBox() {
      this.selgdsDateBox = false;
    },
   telDlog(type,phone,vals){
     this.verifyAliChannelShortMsg(type,phone,vals)
    },
    verifyAliChannelShortMsg(type,phone,vals){
      if(type==true){
        if(vals==''){
          Message.error({ message: '验证码不能为空！' });
          return
        }
        Api.VERIFYALICHANNELSHORTMSG({receivertel:phone, code:vals}).then(res =>{
           if(res.data.status=="200"){
              if(res.data.data==true){
                this.checkVisible = false
                this.alivmfrom()
              }else{
                 Message.error({ message:res.data.message});
              }
           }
        })
      }else{
        this.checkVisible = false
      }
    },
    //提交表单
    submitDeliveryForm() {
       this.$refs["telDeliveryForm_ref"].validate(valid => {
          if (valid) {
              if(this.alivm){ // 打开
                Api.ISALICHANNEL({}).then(res =>{
                  if(res.data.status=="200"){
                    if(res.data.data==true){
                      this.checkVisible = true;
                    }else if(res.data.data==false){
                        this.checkVisible = false;
                        this.alivmfrom()
                    }
                  }
                })
              }else{ //关闭
              this.alivmfrom()
              }
            } else {
                return false;
              }
      });
    },
    alivmfrom(){
          this.submitLoading = true;
          let param = {
            delimode: 1,
            receivername: this.telDeliveryForm.receiptName,
            receivertel: this.telDeliveryForm.receiptTel,
            addrdet: this.telDeliveryForm.receiptAddrDetail,
            cmpname: this.telDeliveryForm.companyName,
            othtel: this.telDeliveryForm.backupTel,
            email: this.telDeliveryForm.receiptemail,
            cardholdertel: this.telDeliveryForm.cardHolderTel,
            recvdate: this.telDeliveryForm.sendDate,
            buyermemo: this.telDeliveryForm.buyerMemo,
            ordermemo: this.telDeliveryForm.orderMemo,
            terminaltype: 0,
            apm: this.telDeliveryForm.timeSlot
          };
          if (this.bindMemberInfo) {
            param.membercode = this.bindMemberInfo.mcode;
          }
          if (this.pubordprintinfo.bopendisrange === 1) {
            if (this.isAreaRange3) {
              // 三级：省市区均来自配送至（与收货地址同步）
              Object.assign(param, {
                provincecode: this.serviceForm.sendToAddr[0].code,
                province: this.serviceForm.sendToAddr[0].name,
                citycode: this.serviceForm.sendToAddr[1].code,
                city: this.serviceForm.sendToAddr[1].name,
                districtcode: this.serviceForm.sendToAddr[2].code,
                district: this.serviceForm.sendToAddr[2].name
              });
            } else {
              Object.assign(param, {
                provincecode: this.serviceForm.sendToAddr[0].code,
                province: this.serviceForm.sendToAddr[0].name,
                citycode: this.serviceForm.sendToAddr[1].code,
                city: this.serviceForm.sendToAddr[1].name,
                districtcode: this.telDeliveryForm.receiptAddr[0].code,
                district: this.telDeliveryForm.receiptAddr[0].name
              });
            }
          } else {
            Object.assign(param, {
              provincecode: this.telDeliveryForm.receiptAddr[0].code,
              province: this.telDeliveryForm.receiptAddr[0].name,
              citycode: this.telDeliveryForm.receiptAddr[1].code,
              city: this.telDeliveryForm.receiptAddr[1].name,
              districtcode: this.telDeliveryForm.receiptAddr[2].code,
              district: this.telDeliveryForm.receiptAddr[2].name
            });
          }
          Api.SUBMITORDER(param).then(res => {
            if (res.data.status === "200") {
              this.initPick();
              // MessageBox.alert(
              //   '<div class="alertBox"><h2 class="comAlert">提货成功！</h2><p>生成订单号：' +
              //     res.data.data.orderno +
              //     "</p></div>",
              //   "系统提示",
              //   {
              //     type: "success",
              //     confirmButtonText: "确定",
              //     dangerouslyUseHTMLString: true
              //   }
              // ).then(() => {}).catch(() => {});
              this.orderno = res.data.data.orderno;
              this.submitDeliveryBox = true;
            } else {
              Message.error({ message: res.data.message });
            }
            this.submitLoading = false;
          });
    },
    consumpteTimesChange: function($event, item) {
      Api.SETCARDUSENUM({ code: item.code, usenum: $event }).then(res => {
        let status = res.data.status;
        if (status != 200) {
          item.consumpteTimes =
            $event - 1 > item.residuenum ? item.residuenum : $event - 1;
        }
      });
    },
    //  券卡验证
    validate: function() {
      // 开通配送范围，必须选择配送至
      if (
        this.pubordprintinfo.bopendisrange === 1 &&
        this.serviceForm.sendToAddr.length < this.sendToMinLen
      ) {
        Message.error({ message: "请选择配送至！" });
        return;
      }

      let param = { pickway: this.serviceForm.verifyType };
      param.code =
        param.pickway === 0
          ? this.serviceForm.cardCode
          : this.serviceForm.cardSerial;

      if (!param.code) {
        Message.error({
          message: "请输入" + (param.pickway === 0 ? "券卡编码" : "券卡序列号")
        });
        return;
      }
      if(param.pickway === 0&&this.serviceForm.cardCode.length!=16&&this.serviceForm.cardCode.length!=20) {
        Message.error({
          message: `请输入16位或20位券卡编码`
        });
        return;
      }
      if(this.ischeckpwd==1){
         param.pwd = this.serviceForm.cardPwd;
          if (!param.pwd) {
            Message.error({
              message: "请输入券卡密码"
            });
            return;
          }
      }
      this.validateLoading = true;
      Api.VALIDATE(param)
        .then(res => {
          if (res.data.status !== "200") {
            Message.error({ message: res.data.message });
            this.validateLoading = false;
            return;
          }
          let data = res.data.data;
          let codeinfo = data.codeinfo;

          let validateInfo = {
            code: codeinfo.code,
            serial: codeinfo.serial,
            sellChannel: codeinfo.channelname,
            printMemo: codeinfo.printmemo,
            memo: codeinfo.sermemo,
            cardoutmemo: data.memo,
            consumpteTimes: 1, // 默认1
            residuenum: codeinfo.residuenum,
            canChangeGoods: true,
            goods: []
          };

          this.currentEnAbleEdite = true;
          let needChooseGoods = true;
          if (data.resulttype === 0) {
            // 有默认商品，且默认商品状态可选，自动选择默认商品
            let resultinfo = data.resultinfo;
            if (resultinfo.defaultSetStatus === "000") {
              // 默认商品设置成功
              validateInfo.canChangeGoods = resultinfo.selgoods.length > 1;
              this.currentEnAbleEdite = resultinfo.selgoods.length > 1;
              // 返回数据中默认商品放在第一个
              validateInfo.goods = [resultinfo.selgoods[0]];
              validateInfo.goodsMap = { singleList: [resultinfo.selgoods[0]] };
              needChooseGoods = false;
              this.notForceGoodsOutDateLimitMessage(resultinfo.isoutgooddate);
              this.notForceGoodsOutRangeLimitMessage(resultinfo.isoutgoodrange);
              // 校验已选商品中是否有地图配送商品
              this.checkMapGoods();
              this.clearCodeParam();
            } else if (resultinfo.defaultSetStatus === "001") {
              // 只有默认商品设置失败
              MessageBox.confirm("券卡绑定商品不可用，默认商品不可用！", '系统提示', {
                confirmButtonText: '关闭',
                showCancelButton: false,
                type: 'warning'
              }).then(() => {}).catch(() => {})
              // Message.warning({
              //   message: "券卡绑定商品不可用，默认商品不可用！"
              // });
              return;
            } else {
              // 有默认有可选，默认商品设置失败
              validateInfo.canChangeGoods = true;
              this.currentEnAbleEdite = true;
              needChooseGoods = true;
            }
          }
          if (needChooseGoods) {
            // 没有默认商品，弹出商品选择
            if (data.resultinfo.isoutcarddate === 1) {
              // this.$alert(
              //   "警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！",
              //   "系统提示",
              //   {
              //     confirmButtonText: "确定",
              //     callback: action => {
              //       this.currentCode = codeinfo.code;
              //       this.currentUseTimes = validateInfo.consumpteTimes;
              //       this.currentCodeInfo = validateInfo;
              //       this.firstTimes = true;
              //       this.goodsChoseDialogVisible = true;
              //     }
              //   }
              // );
              MessageBox.confirm("警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！", '系统提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'warning'
              }).then(() => {
                this.currentCode = codeinfo.code;
                this.currentUseTimes = validateInfo.consumpteTimes;
                this.currentCodeInfo = validateInfo;
                this.firstTimes = true;
                this.goodsChoseDialogVisible = true;
              }).catch(() => {})
            } else {
              console.log("ddddddddddddd");
              this.currentCode = codeinfo.code;
              this.currentUseTimes = validateInfo.consumpteTimes;
              this.currentCodeInfo = validateInfo;
              this.firstTimes = true;
              this.goodsChoseDialogVisible = true;
            }
          } else {
            // 不强制限制券卡有效期
            this.notForceCardLimitMessage(data.resultinfo.isoutcarddate);
            this.cardVertifyData.push(validateInfo);
          }
          this.validateLoading = false;
        })
        .catch(res => {
          this.validateLoading = false;
        });
    },
    notForceCardLimitMessage: function(iscardoutdate) {
      let forceDeliveryDate = this.pubordprintinfo.forcedeliverydate;
      if (forceDeliveryDate === 0 && iscardoutdate) {
        MessageBox.confirm("警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！", '系统提示', {
          confirmButtonText: '关闭',
          showCancelButton: false,
          type: 'warning'
        }).then(() => {}).catch(() => {})
        // Message.warning({
        //   offset: 75,
        //   message: "警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！"
        // });
      }
    },
    notForceGoodsOutDateLimitMessage: function(isgoodsoutdate) {
      let forceDeliveryDate = this.pubordprintinfo.forcedeliverydate;
      if (forceDeliveryDate === 0 && isgoodsoutdate) {
        MessageBox.confirm("警示！默认商品不在销售日期内，提货需按照企业当前的发货政策进行！", '系统提示', {
          confirmButtonText: '关闭',
          showCancelButton: false,
          type: 'warning'
        }).then(() => {}).catch(() => {})
        // Message.warning({
        //   message:
        //     "警示！默认商品不在销售日期内，提货需按照企业当前的发货政策进行！"
        // });
      }
    },
    notForceGoodsOutRangeLimitMessage: function(isgoodsoutRange) {
      let forcedeliveryrange = this.pubordprintinfo.forcedeliveryrange;
      if (forcedeliveryrange === 0 && isgoodsoutRange) {
        MessageBox.confirm("警示！默认商品超出配送范围，提货需按照企业当前的发货政策进行！", '系统提示', {
          confirmButtonText: '关闭',
          showCancelButton: false,
          type: 'warning'
        }).then(() => {}).catch(() => {})
        // Message.warning({
        //   message:
        //     "警示！默认商品超出配送范围，提货需按照企业当前的发货政策进行！"
        // });
      }
    },
    clearCodeParam: function() {
      this.serviceForm.cardCode = "";
      this.serviceForm.cardPwd = "";
      this.serviceForm.cardSerial = "";
    },
    // 提货初始化
    initPick: async function() {
      let initParam = { delimode: 1 };
      // 开通配送范围，必须选择配送至
      if (this.pubordprintinfo.bopendisrange === 1) {
        if (this.serviceForm.sendToAddr.length < this.sendToMinLen) {
          Message.warning({ message: "请选择配送至！" });
          return;
        }
        Object.assign(initParam, {
          provincecode: this.serviceForm.sendToAddr[0].code,
          citycode: this.serviceForm.sendToAddr[1].code
        });
        // 开通配送范围且配置为省市区三级
        if (this.isAreaRange3) {
          Object.assign(initParam, {
            districtcode: this.serviceForm.sendToAddr[2].code
          });
        }
      } else {
      }
      // 重置表单
      this.currentCode = "";
      this.currentUseTimes = 1;
      this.currentCodeInfo = null;
      this.currentEnAbleEdite = true;
      this.apmShow = false;
      this.cardVertifyData = [];
      this.historyAddrData = [];
      this.bindMemberInfo = null;
      this.telDeliveryForm = {
        receiptTel: "", //收货人电话
        receiptName: "", //收货人姓名
        receiptemail: "", //邮箱
        receiptAddr: [], //收货省市区
        receiptAddrDetail: "", //收货详细地址
        cardHolderTel: "", //持卡人电话
        sendDate: "", //期望发货日期
        backupTel: "", //备用电话
        companyName: "", //公司名称
        buyerMemo: "", //买家备注
        orderMemo: "", //订单备注
        timeSlot: -1
      };
      // 三级时重置后同步收货地址与配送至
      this.syncReceiptAddrFromSendTo();
      // 提货页面初始化
      await Api.INITIALIZE(initParam).then(res => {
        if (res.data.status !== "200") {
          Message.error({ message: "提货初始化失败，请刷新重试！" });
        }
      });
    },
    //关闭商品汇总弹窗
    getCloseSummaryBox(){
      this.cardOrderno = '';
      this.goodsSummary = false;
    },
    //查看订单详情
    orderCardInfo(){
      this.cardOrderno = this.orderno;
      this.submitDeliveryBox = false;
      this.goodsSummary = true;
    },
    // 关闭订单详情弹窗
    closeSubmitPop() {
      this.cardOrderno = '';
      this.submitDeliveryBox = false;
    }
  },
  watch: {
    "serviceForm.sendToAddr": {
      handler: function(newValue, oldValue) {
        console.log("serviceForm.sendToAddr", newValue);
      },
      deep: true
    },
    // 收货手机号监听，11位获取提货历史记录
    "telDeliveryForm.receiptTel": {
      handler: function(newValue, oldValue) {
        this.telDeliveryForm.receiptTel = this.PositiveNumberStringWithZero(newValue);
        if (this.telDeliveryForm.receiptTel && this.telDeliveryForm.receiptTel.length == 11) {
          let param = { receivertel: this.telDeliveryForm.receiptTel };
          Api.GET_PICKADDRESSPASTRECORDS(param).then(res => {
            if (
              res.data.status === "200" &&
              res.data.data &&
              res.data.data.length > 0
            ) {
              this.historyAddrData = res.data.data;
            }
          });
        }
      }
    }
  },
  created() {
    // 预售配置
    this.presellconfig = this.config.getPresellconfig();
    // 公共配置
    this.pubordprintinfo = this.config.getPubordprintinfo();
  },
  mounted() {
    if(this.ElementControls('alivm')==1){
       this.alivm = true;
    }else{
       this.alivm = false;
    }
    if(localStorage.getItem('userInfoMd')){
       this.ischeckpwd = JSON.parse(localStorage.getItem('userInfoMd')).ischeckpwd;
       console.log(this.ischeckpwd,'密码')
    }
    // 不开通配送范围时页面初始化
    if (this.pubordprintinfo.bopendisrange === 0) {
      this.initPick();
    }
  },
  computed: {
    chooseInitGoods: function() {
      if (this.currentCodeInfo) {
      }

      return [];
    },
    // goodsAreaRange: 0省市/1省/2省市区 —— 仅 ==2 时配送至与过滤升到区县
    isAreaRange3: function() {
      return this.ElementControls("goodsAreaRange") == 2;
    },
    sendToLevel: function() {
      return this.isAreaRange3 ? 2 : 1;
    },
    sendToMinLen: function() {
      return this.isAreaRange3 ? 3 : 2;
    },
    sendToPlaceholder: function() {
      return this.isAreaRange3 ? "请选择省市区" : "请选择省市";
    },
    receiptAddrLevel: function() {
      if (this.pubordprintinfo && this.pubordprintinfo.bopendisrange === 1) {
        return this.isAreaRange3 ? 2 : 0;
      }
      return 2;
    },
    receiptAddrInitCode: function() {
      if (
        this.pubordprintinfo &&
        this.pubordprintinfo.bopendisrange === 1 &&
        !this.isAreaRange3
      ) {
        return this.serviceForm.sendToAddr.length > 0
          ? this.serviceForm.sendToAddr[1].code
          : "";
      }
      return "0";
    },
    receiptAddrPlaceholder: function() {
      if (this.pubordprintinfo && this.pubordprintinfo.bopendisrange === 1) {
        return this.isAreaRange3 ? "请选择省市区" : "请选择区县";
      }
      return "请选择省市区";
    },
    isReceiptAddrDisabled: function() {
      return !!(
        this.pubordprintinfo &&
        this.pubordprintinfo.bopendisrange === 1 &&
        this.isAreaRange3
      );
    },
    serviceTypeData: function() {
      let serviceTypeData = [];
      let cuspickway = this.pubordprintinfo.cuspickway;
      serviceTypeData.push({ name: "卡号", value: 0 });
      if (cuspickway === 1) {
        serviceTypeData.push({ name: "序列号", value: 1 });
      }
      // 设置默认提货方式
      this.serviceForm.verifyType = this.pubordprintinfo.defcuspickway;

      return serviceTypeData;
    }
  }
};
</script>
<style scoped>
@import "Css/Style.css";
/*提货表单布局 start*/
.goodsWrap >>> .el-form-item__content {
  width: 65%;
  min-width: 200px;
  max-width: 340px;
}
.goodsWrap >>> .el-form-item__content .el-select,
.goodsWrap >>> .el-form-item__content .el-cascader,
.goodsWrap >>> .el-date-editor--daterange.el-input__inner,
.goodsWrap >>> .el-form-item__content .el-date-editor {
  width: 100%;
}
.goodsWrap {
  width: 100%;
  -webkit-display: flex;
  display: flex;
}
.deliveryForm .commonTit {
  margin-bottom: 30px;
  margin-top: 20px;
}
.cardVertifyTab {
  color: #666;
}
.cardVertifyTab >>> .el-table__body tr td:last-child .icondw {
  color: var(--main-color);
}

.defineRow {
  position: relative;
}
.defineRow .btnRight {
  position: absolute;
  left: calc(100% + 10px);
  display: inline-block;
  white-space: nowrap;
  cursor: pointer;
  color: #666;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.defineRow >>> .el-select.selSlot {
  width: 100px;
}

/*查看销售日期弹窗*/
.goodsDateDlog >>> .el-dialog {
  width: 600px;
}
.goodsDateDlog >>> .el-table td,
.goodsDateDlog >>> .el-table th {
  text-align: center;
}
.goodsWrap >>> .el-form-item.mb0 {
  margin-bottom: 0;
}
/*超出配送范围弹窗提示 start*/
.outAreaDlg >>> .el-dialog { width: 650px; }
.outAreaDlg h4 {padding-bottom:20px; font-size: 14px;}
.outAreaDlg h4 em {padding:0 5px; color:#ff7018;}
.outAreaDlg p {line-height: 25px; color:#ff7018}
.outAreaDlg ul {width:80%; margin:10px 0;max-height:100px;overflow-y: auto;}
.outAreaDlg ul li {display:block; line-height:20px; width:100%; overflow: hidden; text-overflow:ellipsis;white-space:nowrap; font-size: 12px;}
.outAreaDlg .inlineUl {width:100%;display:-webkit-flex;display:flex; flex-wrap: wrap; align-items: center;}
.outAreaDlg .inlineUl li {width:calc(50% - 20px);margin-right:20px;}
/*超出配送范围弹窗提示 end*/

/*商品汇总start */
.goodsSummary {margin-left:30px;color:var(--main-color);font-size: 14px;}
.goodsSummary:before {padding-right:5px;}
.goodsSummary:hover {opacity:.8;}
/*确认提示框 */
.alertMsgDlog >>> .el-dialog {width:420px;border-radius:4px;overflow: hidden;padding-bottom:20px;}
.alertBox {position:relative;width:80%;margin:0 auto; padding:17px 10px 17px 36px;}
.alertBox .el-icon-success{position:absolute; left:0; top:15px;color:#67C23A;font-size: 24px;}
.msgBtns {text-align: center;padding:5px 15px 0;}
.alertMsgDlog small {color:#999;font-size: 12px;padding:10px 0;}
/*商品汇总end */

.labelTip {position:absolute;top:0; left:-180px; box-sizing: border-box; width:180px;padding-right:12px;text-align: right;line-height: 25px;}
.labelTip small {display: block;color:#FA2F2F}
</style>




// WEBPACK FOOTER //
// src/views/OrderFolder/TelDelivery.vue